"use client";
import { Close, Title } from "@radix-ui/react-dialog";
import * as Tabs from "@radix-ui/react-tabs";

import useWishlistModal from "@/lib/hooks/useSelection/cart/useWishlist";
import { useWishlist } from "@/lib/wishlist/hooks";
import styles from "../Cart/cart.module.css";

// Dupilcated code from Cart since Radix was making problems.
const WishlistHeader = () => {
  const { cart } = useWishlistModal();
  const { items } = useWishlist();
  return (
    <div className={styles["cart-header"]}>
      <Tabs.List aria-label="Manage your account">
        <Tabs.Trigger value="cart" className={styles.title}>
          <Title className={styles.title}>
            SHOPPING CART (
            {cart.summary?.totalQuantity && `${cart.summary?.totalQuantity}`})
          </Title>
        </Tabs.Trigger>

        <Tabs.Trigger value="wishlist" className={styles.title}>
          WISHLIST
          {items.length ? `(${items.length})` : ""}
        </Tabs.Trigger>
      </Tabs.List>
      <Close asChild>
        <button className={styles["close-button"]}>X</button>
      </Close>
    </div>
  );
};

export default WishlistHeader;
